import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import * as React from "react";

import FormPasswordProfil from "../FormPasswordProfil/FormPasswordProfil";
import Popin from "../Popin/Popin";
import { quotationFormStyles } from "../QuotationForm/QuotationForm.styles";

type PopinPasswordProfileProps = {
    open: boolean;
    onSubmit: (currentPassword?: string, newPassword?: string) => void;
    onCancel();
};

class PopinPasswordProfile extends React.Component<PopinPasswordProfileProps & WithStyles<typeof quotationFormStyles>> {
    public render() {
        return (
            <Popin open={this.props.open} maxWidth="sm" title="Modifier mon mot de passe">
                <FormPasswordProfil onSubmit={this.onSubmit.bind(this)} onCancel={this.props.onCancel} />
            </Popin>
        );
    }

    private onSubmit(currentPassword?: string, newPassword?: string) {
        this.props.onSubmit(currentPassword, newPassword);
        this.props.onCancel();
    }
}

export default withStyles(quotationFormStyles)(PopinPasswordProfile);



// WEBPACK FOOTER //
// ./src/components/PopinPasswordProfile/PopinPasswordProfile.tsx